interface ChipFittingInput {
  widths: number[];
  availableWidth: number;
  overflowWidth: number;
  gapWidth: number;
}

export const countChipsThatFit = ({
  widths,
  availableWidth,
  overflowWidth,
  gapWidth,
}: ChipFittingInput): number => {
  let usedWidth = 0;
  let fittingCount = 0;

  for (const [index, width] of widths.entries()) {
    const candidateWidth = usedWidth + (index > 0 ? gapWidth : 0) + width;
    const isLast = index === widths.length - 1;
    const reservedWidth = isLast ? 0 : gapWidth + overflowWidth;
    if (candidateWidth + reservedWidth > availableWidth) {
      break;
    }
    usedWidth = candidateWidth;
    fittingCount = index + 1;
  }

  return Math.max(1, fittingCount);
};
